/// <reference types="vite-plugin-svgr/client" />
/// <reference types="vite/client" />
import 'draft-js/dist/Draft.css';
import Radium from 'radium';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import type { Store } from 'redux';

import BeamerScriptLoader from 'components/BeamerScriptLoader';
import ThirdPartyScriptLoader from 'components/Common/ThirdPartyScriptLoader';

import rawEnv from 'helpers/env';
import { isZoomAppAgent } from 'helpers/zoomApp';

import './index.css';
import './scripts/initSegment';
import './scripts/initSegmentV2';
import './scripts/thirdPartyScripts';

const { StyleRoot } = Radium;

interface IAppBootstrapEnv {
  chargebeeSiteId: string;
  cookieYesId: string;
  hubspotTrackingCode: string;
  name: string;
}

const env = rawEnv as unknown as IAppBootstrapEnv;

const startRevenueBrowserMswIfEnabled = async () => {
  if (
    !import.meta.env.DEV ||
    import.meta.env.VITE_REVENUE_MSW_ENABLED !== 'true'
  ) {
    return;
  }

  const { startRevenueBrowserMsw } = await import(
    './__tests__/regression/revenue/msw/browser'
  );

  await startRevenueBrowserMsw();
};

const renderApp = async () => {
  await startRevenueBrowserMswIfEnabled();

  const { generateHubspotVisitorIdentificationId } = await import(
    'helpers/hubspotLiveChat'
  );
  const App = (await import('./components/App')).default;
  const reduxStore = (await import('./helpers/reduxStore')).default as Store;

  const notInIframe = window === window.parent;
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Unable to find the Avoma app root element.');
  }

  ReactDOM.render(
    <Provider store={reduxStore}>
      <StyleRoot style={{ height: '100%' }}>
        {notInIframe &&
          ['prod', 'staging', 'int'].includes(env.name) &&
          !isZoomAppAgent() && (
            <ThirdPartyScriptLoader
              src={`//js-na1.hs-scripts.com/${env.hubspotTrackingCode}.js`}
              async
              delay={2000}
              id='hs-chat-script-loader'
              onloadCallback={generateHubspotVisitorIdentificationId}
            />
          )}
        {notInIframe && !isZoomAppAgent() && (
          <React.Fragment>
            <ThirdPartyScriptLoader
              src={`//js.hs-scripts.com/${env.hubspotTrackingCode}.js`}
              async
              delay={10000}
              id='hs-script-loader'
            />
            <ThirdPartyScriptLoader
              src={`https://cdn-cookieyes.com/client_data/${env.cookieYesId}/script.js`}
              async
              delay={5000}
              id='cookieyes'
            />
            <BeamerScriptLoader />
            <ThirdPartyScriptLoader
              src='https://js.chargebee.com/v2/chargebee.js'
              defer
              delay={1000}
              attributes={{
                'data-cb-site': env.chargebeeSiteId
              }}
              id='chargebee-loader'
            />
          </React.Fragment>
        )}
        <App />
      </StyleRoot>
    </Provider>,
    rootElement
  );
};

renderApp();
